import { render, staticRenderFns } from "./IlluProfMusique.vue?vue&type=template&id=67b97be1&"
import script from "./IlluProfMusique.vue?vue&type=script&lang=js&"
export * from "./IlluProfMusique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports